import { defineStore } from 'pinia'
import {
  getGameCategoryList,
  getGamePlatformList,
  getHotGameList,
  getPlayerGameHistory,
  getGameProviderList,
} from '@/service/game'
import { getCurrencyList } from '@/service/wallet'

export const useGameStore = defineStore('game', {
  state: () => ({
    _gameCategoryList: [], // 游戏分类列表
    _currencyList: [], // 货币列表
    _gamePlatformList: [], // 游戏平台列表
    _hotGameList: [], // 热门游戏列表
    _playerGameHistoryList: [], // 玩家游戏历史列表
    _gameProviderList: [], // 一级游戏厂商列表
  }),
  getters: {
    gameCategoryList: (state) => state._gameCategoryList,
    currencyList: (state) => state._currencyList,
    gamePlatformList: (state) => state._gamePlatformList,
    platformCurrency: (state) => state._currencyList.find((item) => item.isDefault),
    hotGameList: (state) => state._hotGameList,
    playerGameHistoryList: (state) => state._playerGameHistoryList,
    gameProviderList: (state) => state._gameProviderList,
  },
  actions: {
    async loadGameCategoryList() {
      if (this._gameCategoryList.length === 0) {
        const res = await getGameCategoryList({
          siteId: Number(import.meta.env.VITE_APP_SITE_ID),
        })
        if (res.code === 0) {
          this._gameCategoryList = res.data
        }
      }
      return this._gameCategoryList
    },
    // 更新游戏分类列表
    async updateGameCategoryList() {
      const res = await getGameCategoryList({
        siteId: Number(import.meta.env.VITE_APP_SITE_ID),
      })
      if (res.code === 0) {
        this._gameCategoryList = res.data.map((item) => ({
          ...item,
          games: item.games.map((game) => ({
            ...game,
            _loaded: true,
          })),
        }))
      }
    },
    async getGameCategoryById(categoryId: string) {
      if (this._gameCategoryList.length === 0) {
        await this.loadGameCategoryList()
      }

      return this._gameCategoryList.find((item) => String(item.id) === categoryId)
    },
    async loadCurrencyList() {
      const res = await getCurrencyList({
        siteId: Number(import.meta.env.VITE_APP_SITE_ID),
      })
      if (res.code === 0) {
        this._currencyList = res.data
      }
      return this._currencyList
    },
    async loadGamePlatformList() {
      if (this._gamePlatformList.length === 0) {
        const res = await getGamePlatformList({
          siteId: Number(import.meta.env.VITE_APP_SITE_ID),
        })
        if (res.code === 0) {
          this._gamePlatformList = res.data
        }
      }
      return this._gamePlatformList
    },
    async updateGamePlatformList() {
      const res = await getGamePlatformList({
        siteId: Number(import.meta.env.VITE_APP_SITE_ID),
      })
      if (res.code === 0) {
        this._gamePlatformList = res.data
      }
    },
    async loadHotGameList() {
      if (this._hotGameList.length === 0) {
        const res = await getHotGameList({
          siteId: Number(import.meta.env.VITE_APP_SITE_ID),
        })
        if (res.code === 0) {
          this._hotGameList = res.data
        }
      }
      return this._hotGameList
    },
    async updateHotGameList() {
      const res = await getHotGameList({
        siteId: Number(import.meta.env.VITE_APP_SITE_ID),
      })
      if (res.code === 0) {
        this._hotGameList = res.data.map((item) => ({
          ...item,
          _loaded: true,
        }))
      }
    },
    async loadPlayerGameHistory() {
      if (this._playerGameHistoryList.length === 0) {
        const res = await getPlayerGameHistory({
          page: 1,
          pageSize: 30,
        })
        if (res.code === 0) {
          const list = res.data.list.map((item) => item.game)
          list.forEach((item) => {
            if (this._playerGameHistoryList.findIndex((game) => game.id === item.id) === -1) {
              this._playerGameHistoryList.push(item)
            }
          })
        }
      }
      return this._playerGameHistoryList
    },
    async updatePlayerGameHistory() {
      const res = await getPlayerGameHistory({
        page: 1,
        pageSize: 30,
      })
      if (res.code === 0) {
        const list = res.data.list.map((item) => item.game)
        list.forEach((item) => {
          if (this._playerGameHistoryList.findIndex((game) => game.id === item.id) === -1) {
            this._playerGameHistoryList.push(item)
          }
        })
      }
    },
    async loadGameProviderList() {
      const res = await getGameProviderList()
      if (res.code === 0) {
        this._gameProviderList = res.data
      }
    },
  },
})
